export const INDEX_MAP_SRC = "/tax-density-map/glastonbury-index-map-042021-1.png";
export const MAP_GRID = {
  left: 2.15,
  top: 9.55,
  cellWidth: 6.01,
  cellHeight: 5.83,
};
export function parseMapId(mapId) {
  const match = String(mapId || "").trim().toUpperCase().match(/^([A-P])(\d{1,2})$/);
  if (!match) return null;

  const row = Number(match[2]);
  if (!Number.isInteger(row) || row < 1 || row > 15) return null;

  return {
    columnIndex: match[1].charCodeAt(0) - "A".charCodeAt(0),
    rowIndex: row - 1,
  };
}

